module.exports = __webpack_public_path__ + "static/media/1.932e2479.gif";